import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"BoardTableViewOrganization"}}
export type BoardTableViewOrganizationQueryVariables = Types.Exact<{
  idOrg: Types.Scalars['ID'];
}>;


export type BoardTableViewOrganizationQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'idEnterprise'>
    & { enterprise?: Types.Maybe<(
      { __typename: 'Enterprise' }
      & Pick<Types.Enterprise, 'id' | 'idAdmins'>
    )>, memberships: Array<(
      { __typename: 'Organization_Membership' }
      & Pick<Types.Organization_Membership, 'idMember' | 'memberType' | 'deactivated' | 'unconfirmed'>
    )> }
  )> }
);


export const BoardTableViewOrganizationDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardTableViewOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idOrg"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idOrg"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idAdmins"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idMember"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"unconfirmed"}}]}}]}}]}}]};

/**
 * __useBoardTableViewOrganizationQuery__
 *
 * To run a query within a React component, call `useBoardTableViewOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardTableViewOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardTableViewOrganizationQuery({
 *   variables: {
 *      idOrg: // value for 'idOrg'
 *   },
 * });
 */
export function useBoardTableViewOrganizationQuery(baseOptions: Apollo.QueryHookOptions<BoardTableViewOrganizationQuery, BoardTableViewOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoardTableViewOrganizationQuery, BoardTableViewOrganizationQueryVariables>(BoardTableViewOrganizationDocument, options);
      }
export function useBoardTableViewOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoardTableViewOrganizationQuery, BoardTableViewOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoardTableViewOrganizationQuery, BoardTableViewOrganizationQueryVariables>(BoardTableViewOrganizationDocument, options);
        }
export type BoardTableViewOrganizationQueryHookResult = ReturnType<typeof useBoardTableViewOrganizationQuery>;
export type BoardTableViewOrganizationLazyQueryHookResult = ReturnType<typeof useBoardTableViewOrganizationLazyQuery>;
export type BoardTableViewOrganizationQueryResult = Apollo.QueryResult<BoardTableViewOrganizationQuery, BoardTableViewOrganizationQueryVariables>;